import { render, staticRenderFns } from "./OrganizationAddPage.vue?vue&type=template&id=139dda66&scoped=true&"
import script from "./OrganizationAddPage.vue?vue&type=script&lang=ts&"
export * from "./OrganizationAddPage.vue?vue&type=script&lang=ts&"
import style0 from "./OrganizationAddPage.vue?vue&type=style&index=0&id=139dda66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139dda66",
  null
  
)

export default component.exports